import React from 'react'
import ContactItem from '../Components/ContactItem';
import phone from '../img/phone.svg';
import email from '../img/emailme.svg';
import location from '../img/location.svg';
import Tittle from '../Components/Tittle';
import emailjs from 'emailjs-com';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



function ContactPage() {
    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('service_5h6iutl', 'template_umad20j', e.target, 'user_F96QTxrBOvGJuJEhaEmCc')
            .then(res => {

                alert('Email successfull Send');


            });

    }
    return (
        <div>
            <div className="title">
                <Tittle title={'CONTACT'} span={'CONTACT'} />
            </div>
            <div className="ContactPage">

                <div className="container border map-sect" style={{ backgroundImage: `url(https://png.pngtree.com/thumb_back/fh260/background/20190222/ourmid/pngtree-blue-fantasy-technology-background-material-backgroundpsd-backgroundadbackground-psdcreative-image_58500.jpg)`, height: '100%', backgroundSize: 'cover' }}>
                    <h1 >Contact Form</h1>
                    <form className='row' style={{ margin: '20px 20px 20px 20px' }} onSubmit={sendEmail}>
                        <label>Name:</label>
                        <input type="text" name="name" className='form-control' required />

                        <label>Email:</label>
                        <input type="email" name="user_email" className='form-control' required />

                        <label>Message</label>
                        <textarea name="message" rows="6" className='form-control'></textarea><br />
                        <input type="submit" value="send" className=' btn btn-primary' style={{ marginTop: '15px' }} />
                    </form>
                    <div className="icons">
                        <a className="icon-holder" href='https://www.linkedin.com/in/alihaydararman/'>
                            <FontAwesomeIcon icon={faLinkedin} className="icon fb" />
                        </a>
                        <a className="icon-holder" href='https://twitter.com/alihaydararman'>
                            <FontAwesomeIcon icon={faTwitter} className="icon fb" />
                        </a>
                        <a className="icon-holder" href='https://github.com/alihaydararman'>
                            <FontAwesomeIcon icon={faGithub} className="icon fb" />
                        </a>
                        <a className="icon-holder" href='https://www.facebook.com/alihaydararman/'>
                            <FontAwesomeIcon icon={faFacebook} className="icon fb" />
                        </a>
                    </div>
                </div>

                <div className="contact-sect">
                    <ContactItem icon={phone} text1={'+8801854046599'} text2={'+8801306749717'} title={'Phone'} />
                    <ContactItem icon={email} text1={'alihaydar6599@gmail.com'} text2={'ali3@dti.ac'} title={'Email'} />
                    <ContactItem icon={location} text1={'Fulgazi, Feni'} text2={'Bangladesh'} title={'Address'} />
                </div>
            </div>
        </div>
    )
}

export default ContactPage;
